import { ActionTree } from 'vuex';
import { RootState, SingleFilter } from '@/store/types';
import api from '@/api';
import * as salesReportRequests from '@/api/requests/sales-report/sales-reports';
import { SalesReportResource} from '@/api/requests/sales-report/types';
import { SalesReportState } from './types';
import SalesReport from '@/api/models/sales-report';


export const actions: ActionTree<SalesReportState, RootState> = {

    /** SalesReports */

    /**
     * Fetch all sales-reports.
     *
     * @param commit
     * @param getters
     */
    async fetchSalesReports({ commit, getters }, filters) {
        await commit('resetSalesReports');
        await commit('resetFilters');
        await commit('setFilters', filters);
        const response = await api.call(salesReportRequests.ALL(getters.httpFilters));
        commit('setSalesReports', response.data.data);
    },

    /**
     * Create a new sales-report.
     *
     * @param commit
     * @param salesReport
     */
    async createSalesReport({ commit }, salesReport: SalesReport) {
        const response = await api.call(salesReportRequests.STORE(salesReport));
        const resource: SalesReportResource = response.data.data;

        commit('addSalesReport', resource);
    },

    /**
     * Delete sales-report by id.
     *
     * @param commit
     * @param salesReportIds
     */
    async deleteSalesReport({ commit }, ...salesReportIds: number[]) {
        await Promise.all(salesReportIds.map(async (salesReportId) => {
            await api.call(salesReportRequests.DELETE(salesReportId));
            commit('removeSalesReport', salesReportId);
        }));
    },

    /**
     * Update an existing salesReport.
     *
     * @param commit
     * @param salesReport
     */
    async updateSalesReport({ commit }, salesReport: SalesReport) {
        if (!salesReport.id) {
            throw new Error('No sales-report id provided.');
        }
        const response = await api.call(salesReportRequests.UPDATE(salesReport.id, salesReport));
        const resource: SalesReportResource = response.data.data;

        commit('updateSalesReport', resource);
    },

    /**
     * Set active salesReport.
     *
     * @param commit
     * @param getters
     * @param salesReportId
     */
    async setActiveSalesReport({ commit, getters }, salesReportId: number) {
        if (!getters.isSalesReportLoaded(salesReportId)) {
            const response = await api.call(salesReportRequests.FIND(salesReportId));
            commit('upsertSalesReport', response.data.data);
        }
        commit('setActiveSalesReportId', salesReportId);
    },

    /** Filters */

    /**
     * Reset a single filter.
     *
     * @param commit
     * @param key
     */
    resetFilter({ commit }, key: string) {
        commit('resetFilter', key);
    },

    /**
     * Set filters.
     *
     * @param commit
     * @param dispatch
     * @param filters
     */
    setFilters({ commit, dispatch }, filters: SingleFilter[]) {
        filters.map((filter) => commit('setFilter', filter));
    },



};
